<template>
  <ob-admin-section
    type="mfdata"
    has-perioade
    import-headers-btn
    :xlsx="false"
    :add="false"
    :edit="false"
    :confirm-value="confirm.dialog"
    @confirmed="_cbConfirmed"
    @itemsSelected="_cbItemsSelected">

    <template slot="section-title">Sectiune Fisiere MF</template>

    <template slot="toolbar-title">Baza de date Fisiere MF</template>

    <template slot="fab" v-if="selectedTab === 0">
      <v-speed-dial
        class="ob-speed-dial"
        v-model="fab"
        absolute
        fixed
        bottom
        right
        direction="top"
        open-on-hover
        transition="scroll-y-reverse-transition"
        key="speeddial">
        <v-btn
          slot="activator"
          v-model="fab"
          color="accent"
          dark
          fab
          key="speed">
          <v-icon>mdi-menu</v-icon>
          <v-icon>mdi-close</v-icon>
        </v-btn>

        <v-tooltip left>
          <span slot="activator">
            <v-btn
              fab
              small
              color="success"
              @click="_cbDownloadMissing">
              <v-icon>mdi-web</v-icon>
            </v-btn>
          </span>
          <span>{{ selected.length ? `Descarca pe server ${selected.length} fisiere de la MF` : 'Descarca pe server toate fisierele care lipsesc (de la MF)' }}</span>
        </v-tooltip>
        <v-tooltip left>
          <span slot="activator">
            <v-btn
              fab
              small
              color="success"
              @click="_cbDownloadToDevice">
              <v-icon>mdi-download</v-icon>
            </v-btn>
          </span>
          <span>{{ selected.length ? `Descarca ${selected.length} pe device` : 'Descarca toate fisierele pe device' }}</span>
        </v-tooltip>
      </v-speed-dial>
    </template>

    <template slot="dialogs">
      <ob-dialog :value="download.dialog" :max-width="500" @close="download.stop = true; download.dialog = false" key="download">
        <template slot="title">
          Descarcare fisiere
        </template>
        <template slot="content">
          <v-progress-linear v-if="download.progress" v-model="download.progress" height="24" color="primary">
            <div class="justify-space-around px-4" style="display: flex; height:100%; align-items: center">
              <span>
                {{ download.text }}
              </span>
              <span>
                {{ download.progress }}%
              </span>
            </div>
          </v-progress-linear>
        </template>
        <template slot="actions">
          <v-spacer></v-spacer>
          <v-btn flat @click="download.stop = true; download.dialog = false">Opreste</v-btn>
        </template>
      </ob-dialog>
    </template>
  </ob-admin-section>
</template>

<script>

import AdminSection from '@/components/AdminSection';
import Dialog from '@/components/Dialog';

export default {
  name: 'mfdata',
  components: {
    'ob-admin-section': AdminSection,
    'ob-dialog': Dialog
  },
  data: () => ({
    type: 'mfdata',
    fab: null,
    selected: [],
    confirm: {
      dialog: false,
      callback: null
    },
    download: {
      dialog: false,
      progress: 0,
      text: '',
      stop: false
    }
  }),
  computed: {
    host () {
      return this.$store.getters.host
    },
    token () {
      return this.$store.getters['token']
    },
    tabs () {
      return this.$store.getters[`${this.type}/tabs`]
    },
    selectedTab () {
      return this.$store.getters[`${this.type}/selectedTab`]
    },
    selectedTabID () {
      return this.$store.getters[`${this.type}/selectedTabID`]
    },
    perioadeTabs () {
      return this.$store.getters[`${this.type}/perioadeTabs`]
    },
    selectedPerioadeTab () {
      return this.$store.getters[`${this.type}/selectedPerioadeTab`]
    }
  },
  methods: {
    _cbConfirmed (value) {
      if (value && this.confirm.callback) this[this.confirm.callback]()
      this.confirm.dialog = false
      this.confirm.callback = null
    },
    _cbItemsSelected (items) {
      this.selected = items
    },
    _cbDownloadMissing () {
      const perioada = this.perioadeTabs[this.selectedPerioadeTab]
      const parts = perioada.label.split('-')
      const year = parts[0]
      const quarter = Math.ceil(((+parts[1][1]) / 3))

      this.$store.dispatch('mfdata/downloadMissing', {
        label: `${year}-T${quarter}`,
        id: perioada._id,
        actions: {
          download: true,
          parse: false,
          compute: false,
          skipExisting: true
        },
        mfdataIds: this.selected
      })
    },
    async _cbDownloadToDevice () {
      try {
        const response = await fetch(`${this.host}/download-mfdata-fsaapi-list`, {
          method: 'post',
          headers: new Headers({
            'Content-Type': 'application/json',
            'Authorization': this.token
          }),
          body: JSON.stringify({ mfdataIds: this.selected, perioada: this.perioadeTabs[this.selectedPerioadeTab]._id })
        })

        const directoryHandle = await window.showDirectoryPicker()
        const permissions = await directoryHandle.requestPermission({ mode: 'readwrite' })

        if (permissions !== 'granted') {
          throw new Error('Permission to write to the folder was not granted.')
        }

        if (response.ok) { // if the response is not ok
          const result = await response.json()

          this.download.dialog = true
          this.download.stop = false
          this.download.progress = 0
          let index = 0

          const worker = async () => {
            while (index < result.length && !this.download.stop) {
              const item = result[index++]
              await this.downloadMFDataFileFromServer(directoryHandle, item)
              this.download.progress = Math.round((index / result.length) * 100)
              this.download.text = `${index} din ${result.length}`
            }
          }

          const workers = Array.from({ length: navigator.hardwareConcurrency * 5 }, () => worker())

          await Promise.all(workers)

          this.download.dialog = false
          this.download.stop = false
        } else {
          throw new Error('Eroare la descarcare fisiere')
        }
      } catch (e) {
        console.error(e)
      }

      // try {
      //   if (this.host !== 'http://localhost:3333' && this.host !== 'http://http://10.194.250.173') {
      //     streamSaver.mitm = `${this.host}/mitm.html`
      //   }
      //   const fileStream = streamSaver.createWriteStream(`TUDs_Analytics_${this.selected.length || ''}_Executii.zip`)
      //   const response = await fetch(`${this.host}/download-mfdata`, {
      //     method: 'post',
      //     headers: new Headers({
      //       'Content-Type': 'application/json',
      //       'Authorization': this.token
      //     }),
      //     body: JSON.stringify({ mfdataIds: this.selected, perioada: this.perioadeTabs[this.selectedPerioadeTab]._id })
      //   })

      //   // more optimized
      //   if (response.body.pipeTo) {
      //     return response.body.pipeTo(fileStream).then(() => console.log('done writing'))
      //   }

      //   const writer = fileStream.getWriter()
      //   const reader = response.body.getReader()
      //   const pump = () => reader.read().then(({ value, done }) => {
      //     if (done) {
      //       // close the stream so we stop writing
      //       writer.close()
      //     } else {
      //       // Write one chunk, then get the next one
      //       writer.write(value).then(pump)
      //     }
      //   })

      //   // Start the reader
      //   pump()
      // } catch (e) {
      //   console.error(e)
      // }
    },
    async downloadMFDataFileFromServer (directoryHandle, item) {
      const file = item.filename
      const url = `${this.host}/download-mfdata-fsaapi-file`
      const fileResponse = await fetch(url, {
        method: 'post',
        headers: new Headers({
          'Content-Type': 'application/json',
          'Authorization': this.token
        }),
        body: JSON.stringify({
          cif: item.cif,
          raport: item.raport,
          filename: file
        })
      })

      if (!fileResponse.ok) {
        console.error(`Failed to fetch file: ${file}`)
        return
      }

      const fileBlob = await fileResponse.blob()
      const fileHandle = await directoryHandle.getFileHandle(file, { create: true })
      const writableStream = await fileHandle.createWritable()
      await writableStream.write(fileBlob)
      await writableStream.close()
    }
  },
  created () {
    this.$store.dispatch(`${this.type}/setEventWatchers`)
    this.$store.dispatch(`${this.type}/fetchHeaders`)
    this.$store.dispatch(`${this.type}/fetchItems`)
    this.$store.dispatch(`${this.type}/fetchPerioadeTabs`)
  }
}
</script>

<style>

</style>
